module.exports = __webpack_public_path__ + "img/logo-cryptopay.c1bd4964.svg";